const TimingFunctions = {
  easeOut: {
    back: 'cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    circ: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)'
  },
  easeInOut: {
    expo: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)'
  }
}

export default TimingFunctions
